let appType;

function getAppTypeState () {
  return appType; // 'seller' || 'default'
}

function isCurrentAppSeller () {
  return getAppTypeState() === 'seller';
}

function isCurrentAppDefault () {
  return getAppTypeState() === 'default';
}

function setAppType (type) {
  if (['seller', 'default'].includes(type)) {
    appType = type;
    document.body.id = `app-type-${type}`;
  }
}

export {
  getAppTypeState,
  setAppType,
  isCurrentAppSeller,
  isCurrentAppDefault
};
